import React, { useState, useEffect, useRef } from "react";
import { FaArrowRight, FaCopy, FaCheck, FaArrowLeft, FaArrowRight as FaNext } from "react-icons/fa";
import "./PHP.css";

function PHP() {
  const text = "Welcome back PHP Dev";
  const [displayedText, setDisplayedText] = useState("");
  const [charIndex, setCharIndex] = useState(0);
  const [expanded, setExpanded] = useState(null);
  const [copied, setCopied] = useState(null);
  const contentRef = useRef(null);

  useEffect(() => {
    if (charIndex < text.length) {
      const timeout = setTimeout(() => {
        setDisplayedText(text.substring(0, charIndex + 1));
        setCharIndex(charIndex + 1);
      }, 100);
      return () => clearTimeout(timeout);
    }
  }, [charIndex, text]);

  const services = [
    // Your services array remains the same

    {
      id: 1,
      title: "Mpesa Integration",
      content: `PAYBILL/TILL APPLICATION PROCESS

Before we go through the hectic application process, 
Lets answer the question Which one should you choose? Paybill or till?
A short answer, It depends

If you intend to intergrate online mpesa payments to your system, 
paybill and till(BuyGoods) application requirements are almost similar.

So the choice of whether to apply for a paybill or till all depends on how you intend to use it.

If your website requires only and only system online payments i.e via stkpush, then you can go for till, 
But if at a certain point you will need to track offline payments, 
Then a paybill is the ideal choice

since it provides the account number option that can act as a unique identifier for your transaction

Not to limit yourself from scalability of your application, 
Always go for a Paybill since it has all capabilities a till has plus an added advantage

NB// :
Individual till and bank paybills cannot be used for mpesa integrations, 
To integrate mpesa online payments with bank paybill or personal till 
you can use a service like Lipia-online

Once you're done, An Visit Daraja Mpesa Portal, create an APP
An App will be created with the Consumer Keyand Consumer secret provided
For live apps, the PASSKEY will be sent via email immediately after going live

Having gotten the three,
Consumer Key
Consumer Secret
PassKey

We should be done with the daraja portal.

Lets now dive into the actual code:;

<?php
function getAccessToken() {
    $consumerKey = "yourConsumerKey";
    $consumerSecret = "yourConsumerSecret";
    
    //choose one depending on you development environment
    //sandbox
    $url = "https://sandbox.safaricom.co.ke/oauth/v1/generate?grant_type=client_credentials"; 
    //live
    $url = "https://api.safaricom.co.ke/oauth/v1/generate?grant_type=client_credentials"; 
    
    try {
        $encodedCredentials = base64_encode($consumerKey . ':' . $consumerSecret);

        $headers = [
            'Authorization: Basic ' . $encodedCredentials,
            'Content-Type: application/json'
        ];

        // Initialize cURL session and set options
        $ch = curl_init();
        curl_setopt($ch, CURLOPT_URL, $url);
        curl_setopt($ch, CURLOPT_HTTPHEADER, $headers);
        curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);

        // Send the request and parse the response
        $response = json_decode(curl_exec($ch), true);

        // Check for errors and return the access token
        if (curl_errno($ch)) {
            throw new Exception('Failed to get access token: ' . curl_error($ch));
        } else if (isset($response['access_token'])) {
            return $response['access_token'];
        } else {
            throw new Exception('Failed to get access token: ' . $response['error_description']);
        }

        // Close the cURL session
        curl_close($ch);
        
    } catch (Exception $error) {
        throw new Exception('Failed to get access token.');
    }
} 

COMPLETE STK CODE

<?php
function sendStkPush() {
    $token = getAccessToken();
    $timestamp = date('YmdHis'); 
    
    $shortCode = "YOUR_PAYBILL"; //sandbox -174379
    $passkey = "YOUR_PASSKEY";
    
    $stk_password = base64_encode($shortCode . $passkey . $timestamp);
    
    //choose one depending on you development environment
    //sandbox
    $url = "https://sandbox.safaricom.co.ke/mpesa/stkpush/v1/processrequest";
    //live
    $url = "https://api.safaricom.co.ke/mpesa/stkpush/v1/processrequest";
    
    $headers = [
        'Authorization: Bearer ' . $token,
        'Content-Type: application/json'
    ];
    
    $requestBody = array(
        "BusinessShortCode" => $shortCode,
        "Password" => $stk_password,
        "Timestamp" => $timestamp,
        "TransactionType" => "CustomerPayBillOnline", //till "CustomerBuyGoodsOnline"
        "Amount" => "10",
        "PartyA" => "254708374149",
        "PartyB" => $shortCode,
        "PhoneNumber" => "254708374149",
        "CallBackURL" => "https://yourwebsite.co.ke/callbackurl",
        "AccountReference" => "account",
        "TransactionDesc" => "test"
    );
    
    try {
        $ch = curl_init();
        curl_setopt($ch, CURLOPT_URL, $url);
        curl_setopt($ch, CURLOPT_POST, 1);
        curl_setopt($ch, CURLOPT_POSTFIELDS, json_encode($requestBody));
        curl_setopt($ch, CURLOPT_HTTPHEADER, $headers);
        curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);
        $response = curl_exec($ch);
        curl_close($ch);
        echo $response;
        return $response;
    } catch (Exception $e) {
        echo 'Error: ',  $e->getMessage(), "
";
    }
}
?>
CONGRATULATIONS. YOU JUST SENT YOR FIRST STK PUSH!!

HANDLING CALLBACK DATA
Lets take a moment and understand what we have done in the previous session, 
So as to understand why this part is one of the most crucial in stk-push integration

{
    "Body": {
        "stkCallback": {
            "MerchantRequestID": "12345-67890-12345",
            "CheckoutRequestID": "abcdefghijklmnopqrstuvwxyz",
            "ResultCode": 0,
            "ResultDesc": "The service was accepted successfully",
            "CallbackMetadata": {
                "Item": [
                    {
                        "Name": "Amount",
                        "Value": 100
                    },
                    {
                        "Name": "MpesaReceiptNumber",
                        "Value": "ABCDEFGHIJ"
                    },
                    {
                        "Name": "Balance"
                        "Value": 0
                    },
                    {
                        "Name": "TransactionDate",
                        "Value": "2023-04-26 12:30:00"
                    },
                    {
                        "Name": "PhoneNumber",
                        "Value": "254712345678"
                    }
                ]
            }
        }
    }
}

Create a callbackData folder to save the contents of the callback data

<?php
// Get the raw POST data from the request
$raw_data = file_get_contents("php://input");

$data = json_decode($raw_data, true);

$filename = "callback_data_" . time() . ".json";

$file_path = dirname(__FILE__) . "/callbackData/" . $filename;
$file = fopen($file_path, "a");

// Write the JSON data to the file
if ($file) {
    fwrite($file, $raw_data);
    fclose($file);
}
//we shall handle the data here
//Eg validating and saving to db

// Finish the request by sending a response back
header("Content-Type: application/json");
echo json_encode(array("status" => "success"));
?>

Handling Callback Complete Code

<?php
// Get the raw POST data from the request
$raw_data = file_get_contents("php://input");

$data = json_decode($raw_data, true);

$filename = "callback_data_" . time() . ".json";

$file_path = dirname(__FILE__) . "/callbackData/" . $filename;
$file = fopen($file_path, "a");

// Write the JSON data to the file
if ($file) {
    fwrite($file, $raw_data);
    fclose($file);
}

// Validate the callback data to check if completed
$result_code = $data['Body']['stkCallback']['ResultCode'];
if ($result_code !== 0) {
    // If the result code is not 0, there was an error
    $error_message = $data['Body']['stkCallback']['ResultDesc'];
    $response_data = array('ResultCode' => $result_code, 'ResultDesc' => $error_message);
    header("Content-Type: application/json");
    echo json_encode($response_data);
    return;
}

// Extract relevant data from the callback
$metadata = $data['Body']['stkCallback']['CallbackMetadata'];

// Get the transaction amount
$amountObj = array_values(array_filter($metadata['Item'], function($obj) {
    return $obj['Name'] === 'Amount';
}));
$amount = $amountObj[0]['Value'] ?? null;

// Get the phone number
$phoneObj = array_values(array_filter($metadata['Item'], function($obj) {
    return $obj['Name'] === 'PhoneNumber';
}));
$phoneNumber = $phoneObj[0]['Value'] ?? null;

// Get the MPESA receipt number
$mpesaCodeObj = array_values(array_filter($metadata['Item'], function($obj) {
    return $obj['Name'] === 'MpesaReceiptNumber';
}));
$mpesaCode = $mpesaCodeObj[0]['Value'] ?? null;

// Save the data to a database
// ...

// Send a success response to M-Pesa
$response_data = array('ResultCode' => $result_code, 'ResultDesc' => 'Success');
header("Content-Type: application/json");
echo json_encode($response_data);

HANDLING OFFLINE PAYBILL/TILL PAYMENTS
Handling offline paybill/till payments is made possible by using the C2B api availed by the mpesa daraja team

This API enables you to register webhooks that will be notified each time a transaction is made to the paybill or till number

The process of intergrating this API is straight forward as it involves some few step worth understanding

REGISTERING URLS
HANDLING WEBHOOK BODY

# STEP 1 - REGISTERING URL
This step involves resgistering callback urls to safaricom to get notified when a customer wants or has paid through the mapped paybill /till

Just like the call back url that is provided on te LIPA NA MPESA(STK PUSH) parameters, these urls in this APIs are registered once and can be changed via the new self service service in the daraja portal

The initial registration of these urls is done via a http POST REQUEST to the REGISTER URLS endpoint provided by the daraja API

There are two URLs required for RegisterURL API: Validation URL and Confirmation URL.

VALIDATION URL:This is a url that will receive the callback before a transaction is completed. In basic terms, when a customer pays to your paybiill, before safaricom completes the payment, If this URL is enabled, Safaricom will check for any rules you set.

A practical use case of the logic writen in this url endpoint is when you would want to limit user paying to your paybill, eg if you expect a fixed amount payed for a certain service, you can reject the completion of transactions that dont fit your logic. Similary when creating a service that identifies users via the account number, You might want to invalidate payments with account numbers that dont exist in your DB

CONFIRMATION URL:This is the most important url since it will receive a POST request with data of a completed transaction

REGISTER URL REQUEST STRUCTURE
// URL
[POST] SANDBOX: https://sandbox.safaricom.co.ke/mpesa/c2b/v1/registerurl
[POST] LIVE:  https://api.safaricom.co.ke/mpesa/c2b/v1/registerurl

// HEADERS
Authorization: Bearer [access token]
Content-Type: application/json

// BODY
{
    "ShortCode": "601426",
    "ResponseType": "[Cancelled/Completed]",
    "ConfirmationURL": "[confirmation URL]",
    "ValidationURL": "[validation URL]"
}
        
ShortCode
This is the paybill number for paybils and store number for till numbers

Response Type
This defined the default action that will happen in case your Validation endpoint cannot be reached or fails to respond promptly. There are only two allowed values: "Completed" or "Cancelled." "Completed" indicates that M-Pesa will finalize the transaction automatically, while "Cancelled" means M-Pesa will automatically terminate the transaction.

Many at times, You wouldnt want to cancell transactions to your till or paybill in the validation url callback handler. So i would advice to keep this field as "Completed" unless you have specific use cases for terminating transactions to your paybill

ConfirmationURL
The callback url for complete transactions.

E.g https://mydomain.co.ke/api/confirmation-url

NB//should be a POST endpoint and will receive a JSON type body on completed transactions to your paybill/till

ValidationURL
The callback url for validation transactions before completion.

E.g https://mydomain.co.ke/api/validation-url

NB//Providing this endpoint in required but writting validation logic to it is optional since safaricom will default to the Response type provided.

SAMPLE RESPONSE ON REGISTERING URLS
{
    "ConversationID": "",
    "OriginatorCoversationID": "",
    "ResponseDescription": "success"
}
        
Any response apart from this will mean an error and you need to fix it.

# STEP 2 - HANDLING WEBHOOK BODY
We will handle the callback data in the confirmation url endpoint handler

Expected request body
{
    "TransactionType": "PayBill",
    "TransID": "LK12345678",
    "TransTime": "2023-08-23T14:30:00+03:00",
    "TransAmount": "1000.00",
    "BusinessShortCode": "123456",
    "BillRefNumber": "Invoice123",
    "InvoiceNumber": "",
    "OrgAccountBalance": "50000.00",
    "ThirdPartyTransID": "TX123456789",
    "MSISDN": "254712345678",
    "FirstName": "John",
    "MiddleName": "Doe",
    "LastName": "Smith"
}
For recent implimentation, The body might be different for newely intergrated paybills/tills as accordance to the data protection rule.
`
    },
    {
      id: 2,
      title: "Web Development",
      content: `
      
      Getting started with PHP for building websites involves several steps, 
      
      from setting up your environment to deploying the site. 
      
      Here's a step-by-step guide to get you started:

1. Set Up Your Development Environment
   - nstall PHP: PHP must be installed on your system. 
   You can download it from [php.net](https://www.php.net/downloads) or use packages like XAMPP or WAMP, which include PHP, MySQL, and Apache server in one bundle.
   - Install a Text Editor/IDE: Choose a code editor like Visual Studio Code, Sublime Text, or PhpStorm.
   
   For PHP, you can also use the built-in editor in IDEs like NetBeans or Eclipse.
   - Set Up a Local Server: Use XAMPP, WAMP, or MAMP to set up a local server on your computer for testing your PHP scripts without the need for an online host.
   - MySQL Database: Install MySQL (part of XAMPP/WAMP/MAMP) to manage your site's data. 
   
   This allows you to store and retrieve information (e.g., users, posts, products).

2. Learn PHP Basics
         - PHP Syntax: 
         
         Understand basic PHP syntax including variables, arrays, loops, functions, and conditionals.
           \`\`\`php
           <?php
           echo "Hello, World!";
           ?>
           \`\`\`
         - Data Types: Learn about PHP’s data types such as strings, integers, floats, and booleans.
         - Forms & User Input: Learn how to collect form data using \`$_POST\`, \`$_GET\`, and \`$_REQUEST\`. Secure user input with \`htmlspecialchars()\` and \`filter_var()\` to avoid injection attacks.
         - Variables and Constants: Use variables to store data and constants to store unchangeable values.
         - PHP Functions: Define reusable code using functions. Learn built-in functions to manipulate data, such as \`strlen()\`, \`substr()\`, \`strpos()\`, etc.

      3. Database Interaction (MySQL)
         - Setting Up a Database: Use phpMyAdmin or command-line MySQL to create a database.
           \`\`\`sql
           CREATE DATABASE my_database;
           \`\`\`
         - Connect to Database: Use PHP’s \`mysqli\` or \`PDO\` (PHP Data Objects) to connect to a MySQL database.
           \`\`\`php
           $conn = mysqli_connect('localhost', 'username', 'password', 'database_name');
           if (!$conn) {
               die("Connection failed: " . mysqli_connect_error());
           }
           \`\`\`
         - CRUD Operations: Learn how to perform Create, Read, Update, and Delete (CRUD) operations on the database.
           \`\`\`php
           // INSERT data
           $sql = "INSERT INTO users (name, email) VALUES ('$name', '$email')";
           mysqli_query($conn, $sql);

           // SELECT data
           $result = mysqli_query($conn, "SELECT * FROM users");
           while ($row = mysqli_fetch_assoc($result)) {
               echo $row['name'];
           }
           \`\`\`

      4. Work with Sessions and Cookies
         - Sessions: Use sessions to store user information across pages (e.g., logged-in users).
           \`\`\`php
           session_start();
           $_SESSION['username'] = 'JohnDoe';
           \`\`\`
         
         - Cookies: Set cookies to store data for long periods.
           \`\`\`php
           setcookie("user", "JohnDoe", time() + 3600);  // Expires in 1 hour
           \`\`\`

      5. Learn About PHP Frameworks (Optional)
         - Why Use Frameworks? Frameworks like Laravel or Symfony provide structure and pre-built components for things like authentication, routing, and database access. Laravel, in particular, is popular for its elegant syntax, security features, and tools for building scalable websites.
         - Start with Laravel: Once you understand core PHP, try learning Laravel if you're working on larger or more complex projects.

      6. Design Your Website (HTML & CSS)
         - HTML: Use HTML to create the structure of your website. PHP is used to add dynamic functionality to the site (like displaying data from a database).
         - CSS: Style your website using CSS or CSS frameworks like Bootstrap to make it responsive and visually appealing.

      7. Create Dynamic Content
         - PHP for Dynamic Pages: Use PHP to fetch and display dynamic content. For example, you can create a blog where new posts are added dynamically from the database.
           \`\`\`php
           <?php
           $result = mysqli_query($conn, "SELECT title, content FROM posts");
           while ($row = mysqli_fetch_assoc($result)) {
               echo "<h2>" . $row['title'] . "</h2>";
               echo "<p>" . $row['content'] . "</p>";
           }
           ?>
           \`\`\`

      8. Add Forms and Validation
         - Create Forms: Use forms to collect user input. For example, a login form can take the username and password, which are then processed using PHP.
         - Validation: Validate the input both client-side (JavaScript) and server-side (PHP). For example, check if an email is valid using \`filter_var()\` in PHP.
           \`\`\`php
           if (!filter_var($email, FILTER_VALIDATE_EMAIL)) {
               echo "Invalid email format";
           }
           \`\`\`

      9. Security Measures
         - Sanitize User Input: Always sanitize user input to prevent SQL injection and cross-site scripting (XSS) attacks.
         - Password Hashing: Use \`password_hash()\` and \`password_verify()\` for securely storing and verifying passwords.
           \`\`\`php
           $hashed_password = password_hash($password, PASSWORD_DEFAULT);
           \`\`\`
         
         - Prepared Statements: Use prepared statements in MySQL to protect against SQL injection.
           \`\`\`php
           $stmt = $conn->prepare("SELECT * FROM users WHERE email = ?");
           $stmt->bind_param("s", $email);
           $stmt->execute();
           \`\`\`

      10. Testing Your Website
         - Local Testing: Test your website on your local machine using a local server like XAMPP or MAMP.
         - Debugging: Use \`var_dump()\` or \`echo\` to output variables and troubleshoot issues.
         - Browser Testing: Test your website on different browsers (Chrome, Firefox, Safari) to ensure compatibility.

      11. Deploy Your Website
         - Choose a Hosting Provider: Pick a hosting service that supports PHP and MySQL (e.g., Bluehost, SiteGround).
         - Upload Your Files: Use FTP or cPanel’s file manager to upload your PHP files and MySQL database to your hosting server.
         - Configure Database: Create the same database and tables on the hosting server and import data (if necessary).
         - Test Live Website: Once your website is live, test all functionalities to ensure it works as expected in the production environment.

      12. Maintain and Update Your Website
         - Bug Fixes: Regularly fix bugs and issues that arise as users interact with your site.
         - Security Updates: Stay updated with the latest PHP versions and security patches to protect against vulnerabilities.

      Additional Tips:
         - Learn Version Control: Use Git to track changes and collaborate with others.
         - Documentation: Regularly document your code for future reference.
         - Community: Engage with PHP communities (forums, StackOverflow, etc.) to learn and ask questions.

      Starting with PHP might feel overwhelming, but by following this structured approach and building projects as you learn, you'll gain proficiency and confidence in using PHP for web development.
`
    },
    {
      id: 3,
      title: "SMS Integration",
      content: `
    # SMS Integration Guide
    
    ## Overview
    Integrate SMS functionality into your application using the **UMSComms** API. This guide explains how to send SMS messages programmatically.
    
    ## Step 1: Obtain API Credentials
    To use the SMS API, you must have an API key and an App ID.  
    
    - **Sign up** on [UMSComms](https://comms.umeskiasoftwares.com).
    - **Generate an API key** and App ID from the developer dashboard.
    - **Note down** the credentials for later use.
    
    ## Step 2: Configure API Credentials
    Create a configuration file (config.php) to store your credentials securely:
    
    \`\`\`php
    <?php
    define('API_KEY', 'your_api_key');
    define('APP_ID', 'your_app_id');
    define('API_URL', 'https://comms.umeskiasoftwares.com/api/v1/sms/send');
    ?>
    \`\`\`
    
    ## Step 3: Sending an SMS
    To send an SMS, make a POST request to the API endpoint. Below is a PHP example:
    
    \`\`\`php
    <?php
    include('config.php');
    
    if ($_SERVER['REQUEST_METHOD'] == 'POST') {
        $phone = $_POST['phone'];
        $message = $_POST['message'];
    
        // Append the default STOP message with three line breaks
        $default_message = "\\n\\n\\nMuindi\\nSTOP *456*9*5#";
        $message .= $default_message;
    
        // Send SMS request
        $curl = curl_init();
    
        curl_setopt_array($curl, [
            CURLOPT_URL => API_URL,
            CURLOPT_RETURNTRANSFER => true,
            CURLOPT_POST => true,
            CURLOPT_POSTFIELDS => [
                'api_key' => API_KEY,
                'app_id' => APP_ID,
                'sender_id' => 'UMS_SMS', // Replace with your sender ID
                'message' => $message,
                'phone' => $phone
            ]
        ]);
    
        $response = curl_exec($curl);
        curl_close($curl);
    
        // Decode response
        $result = json_decode($response, true);
    
        // Check if SMS was sent successfully
        if (isset($result['status']) && $result['status'] === 'success') {
            echo "SMS sent successfully!";
        } else {
            echo "Failed to send SMS.";
        }
    }
    ?>
    \`\`\`
    
    ## Step 4: Create an HTML Form
    To allow users to send SMS, create a simple form:
    
    \`\`\`html
    <form method="POST" action="sms.php">
        <label for="phone">Phone Number:</label>
        <input type="text" id="phone" name="phone" required>
        
        <label for="message">Message:</label>
        <textarea id="message" name="message" required></textarea>
    
        <button type="submit">Send SMS</button>
    </form>
    \`\`\`
    
    ## Step 5: Handling API Response
    The API response contains information about the status of the SMS request. A successful response looks like this:
    
    \`\`\`json
    {
        "status": "success",
        "message_id": "12345",
        "cost": "0.5"
    }
    \`\`\`
    
    ## Conclusion
    With these steps, you can successfully integrate SMS functionality into your application using the UMSComms API.
    `
    },    
    
    {
      id: 4,
      title: "Mailers",
      content: `
    # PHP Mailers Guide
    
    ## Overview
    Sending emails from PHP can be done using the built-in \`mail()\` function, but it lacks features like SMTP authentication and HTML emails. **PHPMailer** is a popular library that provides advanced email functionalities, including:
    
    - Sending emails via SMTP (e.g., Gmail, Outlook, custom mail servers).
    - Sending HTML emails.
    - Adding attachments.
    - Using authentication with secure protocols (TLS/SSL).
    
    ## Step 1: Obtaining PHPMailer
    You can install **PHPMailer** in two ways:
    
    ### Method 1: Manual Download
    If you don’t use Composer, you can manually download PHPMailer:
    
    1. Visit the official [PHPMailer GitHub Repository](https://github.com/PHPMailer/PHPMailer).
    2. Download the ZIP file and extract it.
    3. Copy the **PHPMailer** and **SMTP** class files to your project.
    
    Your project folder should look like this:
    
    \`\`\`
    /your_project
      ├── PHPMailer/
      │   ├── PHPMailer.php
      │   ├── SMTP.php
      │   ├── Exception.php
      ├── send_mail.php
    \`\`\`
    
    ### Method 2: Using Composer (Recommended)
    If you have Composer installed, run the following command in your terminal:
    
    \`\`\`sh
    composer require phpmailer/phpmailer
    \`\`\`
    
    This will automatically download PHPMailer and its dependencies into your **vendor/** folder.
    
    ## Step 2: Configuring PHPMailer
    After downloading PHPMailer, create a PHP script to send an email:
    
    \`\`\`php
    <?php
    use PHPMailer\\PHPMailer\\PHPMailer;
    use PHPMailer\\PHPMailer\\Exception;
    
    // Load PHPMailer (use require if manually downloaded)
    require 'vendor/autoload.php'; // For Composer installation
    // require 'PHPMailer/PHPMailer.php'; // If manually downloaded
    // require 'PHPMailer/SMTP.php';
    // require 'PHPMailer/Exception.php';
    
    $mail = new PHPMailer(true); // Enable exceptions
    
    try {
        // SMTP Configuration
        $mail->isSMTP();
        $mail->Host       = 'smtp.example.com'; // Replace with your SMTP server
        $mail->SMTPAuth   = true;
        $mail->Username   = 'your_email@example.com'; // SMTP username
        $mail->Password   = 'your_password'; // SMTP password
        $mail->SMTPSecure = PHPMailer::ENCRYPTION_STARTTLS; // TLS encryption
        $mail->Port       = 587; // Common SMTP port
    
        // Email Content
        $mail->setFrom('your_email@example.com', 'Your Name');
        $mail->addAddress('recipient@example.com'); // Add recipient
        $mail->Subject = 'Test Email from PHPMailer';
        $mail->Body    = 'Hello! This is a test email sent using PHPMailer.';
        
        // Send Email
        $mail->send();
        echo 'Email has been sent successfully!';
    } catch (Exception $e) {
        echo "Email failed to send. Error: {$mail->ErrorInfo}";
    }
    ?>
    \`\`\`
    
    ## Step 3: Running the Script
    - If using **Composer**, simply run:
    
    \`\`\`sh
    php send_mail.php
    \`\`\`
    
    - If using the manual method, ensure that PHPMailer files are included correctly before running the script.
    
    ## Conclusion
    PHPMailer makes it easy to send emails securely with SMTP authentication, attachments, and HTML formatting. Choose **manual download** if you don't use Composer or install via **Composer** for easier dependency management.
    
    `
    }
    
  
  ];

  const toggleExpand = (id) => {
    setExpanded(expanded === id ? null : id);
  };

  const copyToClipboard = (code, id) => {
    navigator.clipboard.writeText(code);
    setCopied(id);
    setTimeout(() => setCopied(null), 1500);
  };

  const handleClickOutside = (event) => {
    if (contentRef.current && !contentRef.current.contains(event.target)) {
      setExpanded(null);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  
  

  return (
    <div className="php-documentation">
      <h1 className="typing-text">{displayedText}</h1>

      <div className="service-list">
        {services.map((service) => (
          <div key={service.id} className="service-item">
            <button className="service-btn" onClick={() => toggleExpand(service.id)}>
              {service.id}. {service.title} <FaArrowRight className="arrow-icon" />
            </button>

            {expanded === service.id && (
              <div className="service-content" ref={contentRef}>
                <div className="content-wrapper">
                  <pre>
                    <code>{service.content}</code>
                  </pre>
                </div>
                <div className="navigation-buttons">
                  <button className="nav-btn" onClick={() => setExpanded(service.id - 1)}>
                    <FaArrowLeft /> Back Services
                  </button>
                  <button className="nav-btn" onClick={() => setExpanded(service.id + 1)}>
                    Next Service <FaNext />
                  </button>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default PHP;